import React, { useEffect, useState, useRef } from 'react';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { IdentityActions, TradeActions, NotificationActions } from '../../../store';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h3": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const tradesSelector = (state) => state.Trades;
const IdentitySelector = (state) => state.Identity;

const TradeDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const tradeActions = bindActionCreators(TradeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(tradesSelector);
    const { token, userData, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    // 確認ダイアログ表示フラグ
    const [dlgOpen, setDlgOpen] = React.useState(false);

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 取消ボタン押下時の処理
     * （返金処理）
     * ※ OKICABusinessAPIの内部で、SmartOKICAAPIをコールしている。
     *
     */
    const onCancelClick = () => {
        // 削除確認ダイアログを表示
        setDlgOpen(true);
    };

    /**
     *
     * 確認ダイアログでの「はい」ボタン押下時の処理（取消実行）
     *
     */
    const onDlgYesClick = () => {
        // 一旦、確認ダイアログを閉じる
        setDlgOpen(false);
        // 取消処理
        tradeActions.cancel(token, editing)
            .then(data => {
                notificationActions.showSuccess('取消しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 確認ダイアログでの「いいえ」ボタン押下時の処理（キャンセル）
     *
     */
    const onDlgNoClick = () => {
        // 削除確認ダイアログを閉じる
        setDlgOpen(false);
    };

    // 返金ボタン表示
    // ・取り消されていない（当該取引IDが他レコードの決済取消_取引IDに設定されていない）
    // ・取消権限あり
    // ・取引日時が７日前までOK
    // ・取引タイプ：1:決済
    // ・決済種別（貸方）：1:SmartOKICA残高 または、3:クレジットカード
    // ・取消されていない
    var cancelButton = <div style={{ height: 40 }}></div>;;
    if (props.cancelFlag) {
        // 取消済みの場合は、非活性でボタン表示
        cancelButton =
            <div>
            <Button fullWidth id="canselButton" variant="contained" size="medium" color="primary"
                    disabled 
                    endIcon={<CancelIcon />}
                    onClick={onCancelClick}><FormattedMessage id={"Trade.Cancel"} /></Button>
            </div>;
    } else if (permissions && permissions.fid2_0 != null && (permissions.fid2_0.value.value & 2) == 2) {
        var flg = false;

        var nowdt = new Date();
        var chkdt = new Date();
        chkdt.setDate(nowdt.getDate() - 7);
        //var chkdt = new Date(nowdt.getTime() - (Number(7) * 24 * 60 * 60 * 1000));
        var trandt = new Date(editing.transaction_dt);
        if ((chkdt <= trandt) &&
            (editing.transaction_type == 1) &&
            (editing.credit_account_type == 1 || editing.credit_account_type == 3) &&
            (editing.payment_cancel_transaction_id == null || editing.payment_cancel_transaction_id == "")) {
            cancelButton =
                <div>
                    <Button fullWidth id="canselButton" variant="contained" size="medium" color="primary"
                        endIcon={<CancelIcon />}
                        onClick={onCancelClick}><FormattedMessage id={"Trade.Cancel"} /></Button>
                </div>;
        }
    }

    // 取引日時
    var transactionDt = new Date(editing.transaction_dt);
    //var transactionDtStr = transactionDt.toLocaleString("ja"); 
    let transactionDtStr = transactionDt.getFullYear()
        + '/' + ('0' + (transactionDt.getMonth() + 1)).slice(-2)
        + '/' + ('0' + transactionDt.getDate()).slice(-2)
        + ' '
        + ('0' + transactionDt.getHours()).slice(-2)
        + ':' + ('0' + transactionDt.getMinutes()).slice(-2)
        + ':' + ('0' + transactionDt.getSeconds()).slice(-2);

    // 取引完了日時
    var fixedDtStr = '－';
    if (editing.fixed_dt != null) {
        var fixedDt = new Date(editing.fixed_dt);
        fixedDtStr = fixedDt.getFullYear()
            + '/' + ('0' + (fixedDt.getMonth() + 1)).slice(-2)
            + '/' + ('0' + fixedDt.getDate()).slice(-2)
            + ' '
            + ('0' + fixedDt.getHours()).slice(-2)
            + ':' + ('0' + fixedDt.getMinutes()).slice(-2)
            + ':' + ('0' + fixedDt.getSeconds()).slice(-2);
    }

    // 加盟店タイプ
    var merchantType = '';
    switch (editing.merchant_type) {
        case 'acquirer':
            merchantType = <FormattedMessage id={"Trade.MerchantType.Acquirer"} />;
            break;
        case 'general':
            merchantType = <FormattedMessage id={"Trade.MerchantType.General"} />;
            break;
    }

    // 取引タイプ
    var transactionType = '';
    switch (editing.transaction_type) {
        case 1:
            transactionType = <FormattedMessage id={"Trade.TransactionType.Fixed"} />;
            break;
        case 2:
            transactionType = <FormattedMessage id={"Trade.TransactionType.Cancel"} />;
            break;
        case 3:
            transactionType = <FormattedMessage id={"Trade.TransactionType.Charge"} />;
            break;

        case 10:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroReserve"} />;
            break;
        case 11:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoro"} />;
            break;
        case 12:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroExpiredRecovery"} />;
            break;
        case 13:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroUnfinishedRecovery"} />;
            break;
        case 14:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroCancelExpired"} />;
            break;
        case 15:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroCancel"} />;
            break;
        case 16:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroCancelCardExchange"} />;
            break;
        case 17:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiKoroCancelRecovery"} />;
            break;

        case 20:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroReserve"} />;
            break;
        case 21:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoro"} />;
            break;
        case 22:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroExpiredRecovery"} />;
            break;
        case 23:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroUnfinishedRecovery"} />;
            break;
        case 24:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroCancelExpired"} />;
            break;
        case 25:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroCancel"} />;
            break;
        case 26:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroCancelCardExchange"} />;
            break;
        case 27:
            transactionType = <FormattedMessage id={"Trade.TransactionType.SmaKoroCancelRecovery"} />;
            break;

        case 31:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiCharge"} />;
            break;
        case 32:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiChargeCancel"} />;
            break;
        case 33:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiFixed"} />;
            break;
        case 34:
            transactionType = <FormattedMessage id={"Trade.TransactionType.OkiCancel"} />;
            break;

        case 40:
            transactionType = <FormattedMessage id={"Trade.TransactionType.PointReduce"} />;
            break;
    }

    // 決済種別(借方)
    var debitAccountType = '';
    switch (editing.debit_account_type) {
        case 1:
            debitAccountType = <FormattedMessage id={"Trade.AccountType.SmartOKica"} />;
            break;
        case 2:
            debitAccountType = <FormattedMessage id={"Trade.AccountType.OkicaCard"} />;
            break;
        case 3:
            debitAccountType = <FormattedMessage id={"Trade.AccountType.CreditCard"} />;
            break;
        case 4:
            debitAccountType = <FormattedMessage id={"Trade.AccountType.Bank"} />;
            break;
        case 5:
            debitAccountType = <FormattedMessage id={"Trade.AccountType.OkicaPoint"} />;
            break;
    }

    // 決済種別(貸方)
    var creditAccountType = '';
    switch (editing.credit_account_type) {
        case 1:
            creditAccountType = <FormattedMessage id={"Trade.AccountType.SmartOKica"} />;
            break;
        case 2:
            creditAccountType = <FormattedMessage id={"Trade.AccountType.OkicaCard"} />;
            break;
        case 3:
            creditAccountType = <FormattedMessage id={"Trade.AccountType.CreditCard"} />;
            break;
        case 4:
            creditAccountType = <FormattedMessage id={"Trade.AccountType.Bank"} />;
            break;
        case 5:
            creditAccountType = <FormattedMessage id={"Trade.AccountType.OkicaPoint"} />;
            break;
    }

    // ステータス
    var status = '';
    switch (editing.status) {
        case 1:
            status = <FormattedMessage id={"Trade.Status.Processing"} />;
            break;
        case 2:
            status = <FormattedMessage id={"Trade.Status.Complete"} />;
            break;
        case -1:
            status = <FormattedMessage id={"Trade.Status.Failure"} />;
            break;
    }

    // 金額
    var debitAmount = '';
    if (editing.debit_amount != null && editing.debit_amount != undefined && editing.debit_amount != '' && !isNaN(editing.debit_amount)) {
        debitAmount = Number(editing.debit_amount).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }
    var creditAmount = '';
    if (editing.credit_amount != null && editing.credit_amount != undefined && editing.credit_amount != '' && !isNaN(editing.credit_amount)) {
        creditAmount = Number(editing.credit_amount).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }

    // OKICAカード_一件明細確定日時
    var cardDtlFinishDtStr = '';
    if (editing.card_dtl_finish_dt != null && editing.card_dtl_finish_dt != undefined) {
        var cardDtlFinishDt = new Date(editing.card_dtl_finish_dt);
        cardDtlFinishDtStr = cardDtlFinishDt.toLocaleString("ja"); 
    }

    //  OKICAカード(IDI)
    var idi = editing.card_idi
    if (!(userData.role == 1 || userData.role == 2)) {
        if (idi != null) {
            if (idi.length > 0 && idi.length <= 17 && idi.substr(0, 2) == "OK") {
                var mask = idi.substr(12, 5);
                idi = "OK**********" + mask;
            }
        } else {
            idi = '－';
        }
    }

    // 決済事業者
    var agency = "";
    if (userData.role == 1 || userData.role == 2) {

        agency = <Grid item xs={12}>
            <table className={classes.table}>
                <tbody>
                    <tr><td><FormattedMessage id={"Trade.TransactionDt"} /></td><td>{transactionDtStr}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.FixedDt"} /></td><td>{fixedDtStr}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.MerchantName"} /></td><td>{editing.merchant_name}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.MerchantType"} /></td><td>{merchantType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.ShopName"} /></td><td>{editing.shop_name}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.TransactionType"} /></td><td>{transactionType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitTitle"} /></td><td>{editing.debit_title}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitAccountType"} /></td><td>{debitAccountType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitAmount"} /></td><td>{debitAmount}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditTitle"} /></td><td>{editing.credit_title}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditAccountType"} /></td><td>{creditAccountType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditAmount"} /></td><td>{creditAmount}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.Remarks"} /></td><td>{editing.remarks}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentNo"} /></td><td>{editing.payment_no}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.TerminalId"} /></td><td>{editing.terminal_id}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentAgencyName"} /></td><td>{editing.payment_agency_name}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditCardGmoForward"} /></td><td>{editing.credit_card_gmo_forward}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditCardGmoApprove"} /></td><td>{editing.credit_card_gmo_approve}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditCardGmoTranId"} /></td><td>{editing.credit_card_gmo_tran_id}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditCardGmoTranDate"} /></td><td>{editing.credit_card_gmo_tran_date}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentBillNumber"} /></td><td>{editing.payment_bill_number}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentCancelTransactionId"} /></td><td>{editing.payment_cancel_transaction_id}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CardIdi"} /></td><td>{idi}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CardDtlSeq"} /></td><td>{editing.card_dtl_seq != null ? editing.card_dtl_seq : ''}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CardDtlSeqLoopCnt"} /></td><td>{editing.card_dtl_seq_loop_cnt != null ? editing.card_dtl_seq_loop_cnt : ''}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CardDtlFinishDt"} /></td><td>{cardDtlFinishDtStr}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.Status"} /></td><td>{status}</td></tr>
                </tbody>
            </table>
        </Grid>;
    } else {
        agency = <Grid item xs={12}>
            <table className={classes.table}>
                <tbody>
                    <tr><td><FormattedMessage id={"Trade.TransactionDt"} /></td><td>{transactionDtStr}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.FixedDt"} /></td><td>{fixedDtStr}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.MerchantName"} /></td><td>{editing.merchant_name}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.MerchantType"} /></td><td>{merchantType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.ShopName"} /></td><td>{editing.shop_name}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.TransactionType"} /></td><td>{transactionType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitTitle"} /></td><td>{editing.debit_title}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitAccountType"} /></td><td>{debitAccountType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.DebitAmount"} /></td><td>{debitAmount}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditTitle"} /></td><td>{editing.credit_title}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditAccountType"} /></td><td>{creditAccountType}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CreditAmount"} /></td><td>{creditAmount}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.Remarks"} /></td><td>{editing.remarks}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentNo"} /></td><td>{editing.payment_no}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.TerminalId"} /></td><td>{editing.terminal_id}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentBillNumber"} /></td><td>{editing.payment_bill_number}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.PaymentCancelTransactionId"} /></td><td>{editing.payment_cancel_transaction_id}</td></tr>
                    <tr><td><FormattedMessage id={"Trade.CardIdi"} /></td><td>{idi}</td></tr>
                </tbody>
            </table>
        </Grid>;

    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit"><FormattedMessage id={"Trade.Title"} /></Typography>
                    </div>
                </Toolbar>

                <form className={classes.form}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h3" variant="inherit"><FormattedMessage id={"Trade.SubTitle"} /></Typography>
                                {cancelButton}
                            </div>
                            {agency}
                            <Divider />
                        </Grid>


                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

            <Dialog
                open={dlgOpen}
                onClose={onDlgNoClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        取引情報を取り消しますか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onDlgYesClick} color="primary">
                        はい
                    </Button>
                    <Button onClick={onDlgNoClick} color="primary" autoFocus>
                        いいえ
                    </Button>
                </DialogActions>
            </Dialog>

        </Container>
    )    
}

export default withStyles(style, { withTheme: true })(TradeDetail);